/* Sunnah shop - effecten voor de homepage-secties */
(function () {
  'use strict';
  if (window.SunnahFX) { window.SunnahFX.scan(document); return; }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }) : null;
  function reveal(root) {
    root.querySelectorAll('.sn-reveal:not(.is-in), .sn-words:not(.is-in)').forEach(function (el) {
      if (io && !reduced) { io.observe(el); } else { el.classList.add('is-in'); }
    });
  }
  function typewriter(el) {
    if (el.__sn) return; el.__sn = true;
    var out = el.querySelector('[data-sn-type-out]');
    var list;
    try { list = JSON.parse(el.getAttribute('data-sn-type')); } catch (e) { return; }
    if (!out || !list || !list.length) return;
    var chars = list.map(function (s) { return Array.from ? Array.from(s) : s.split(''); });
    out.textContent = list[0];
    if (reduced || list.length < 2) return;
    var i = 0, j = chars[0].length, deleting = true;
    function tick() {
      if (!document.body.contains(el)) return;
      if (deleting) {
        j--; out.textContent = chars[i].slice(0, j).join('');
        if (j <= 0) { deleting = false; i = (i + 1) % chars.length; }
        setTimeout(tick, 35);
      } else {
        j++; out.textContent = chars[i].slice(0, j).join('');
        if (j >= chars[i].length) { deleting = true; setTimeout(tick, 2200); } else { setTimeout(tick, 75); }
      }
    }
    setTimeout(tick, 2600);
  }
  var scrubs = [], ticking = false;
  function updateScrubs() {
    ticking = false;
    var vh = window.innerHeight;
    scrubs = scrubs.filter(function (s) { return document.body.contains(s.el); });
    scrubs.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      var p = (vh * 0.9 - r.top) / (r.height + vh * 0.4);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * s.words.length);
      for (var k = 0; k < s.words.length; k++) { s.words[k].classList.toggle('is-lit', k < n); }
    });
  }
  function scrub(el) {
    if (el.__sn) return; el.__sn = true;
    var words = el.querySelectorAll('.sn-scrub__w');
    if (!words.length) return;
    if (reduced) { words.forEach(function (w) { w.classList.add('is-lit'); }); return; }
    scrubs.push({ el: el, words: words });
    updateScrubs();
  }
  window.addEventListener('scroll', function () {
    if (!ticking && scrubs.length) { ticking = true; window.requestAnimationFrame(updateScrubs); }
  }, { passive: true });
  window.addEventListener('resize', function () { if (scrubs.length) updateScrubs(); });
  function carousel(el) {
    if (el.__snCar) return; el.__snCar = true;
    var track = el.querySelector('.sn-car__track');
    var prev = el.querySelector('[data-sn-car-prev]');
    var next = el.querySelector('[data-sn-car-next]');
    if (!track) return;
    function sync() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function step() { return Math.max(track.clientWidth * 0.9, 200); }
    if (prev) { prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); }
    if (next) { next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    el.__snSync = sync;
    sync();
  }
  function bestsellers(el) {
    if (el.__sn) return; el.__sn = true;
    var url = el.getAttribute('data-sn-bestsellers');
    var count = parseInt(el.getAttribute('data-count'), 10) || 8;
    var target = el.querySelector('[data-sn-grid]');
    if (!url || !target || !window.fetch) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-sn-grid]');
        if (!grid || !grid.children.length) return;
        var pinned = Array.prototype.slice.call(target.querySelectorAll('[data-pinned]'));
        var skip = {};
        pinned.forEach(function (li) { skip[li.getAttribute('data-pid')] = true; });
        var frag = document.createDocumentFragment();
        pinned.forEach(function (li) { frag.appendChild(li); });
        var added = pinned.length;
        Array.prototype.forEach.call(grid.children, function (li) {
          if (added >= count) return;
          var pid = li.getAttribute('data-pid');
          if (pid && skip[pid]) return;
          frag.appendChild(document.importNode(li, true));
          added++;
        });
        target.innerHTML = '';
        target.appendChild(frag);
        target.scrollLeft = 0;
        if (el.__snSync) { el.__snSync(); }
      })
      .catch(function () {});
  }
  function autoplay(v) {
    if (v.__sn) return; v.__sn = true;
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    function go() { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    go();
    v.addEventListener('pause', function () { if (!v.ended && !document.hidden) { setTimeout(go, 150); } });
    v.addEventListener('canplay', function () { if (v.paused) { go(); } });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { go(); } });
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, function () { if (v.paused) { go(); } }, { passive: true, once: true });
    });
  }
  function scan(root) {
    root = root || document;
    reveal(root);
    root.querySelectorAll('[data-sn-type]').forEach(typewriter);
    root.querySelectorAll('[data-sn-scrub]').forEach(scrub);
    root.querySelectorAll('[data-sn-car]').forEach(carousel);
    root.querySelectorAll('[data-sn-bestsellers]').forEach(bestsellers);
    root.querySelectorAll('video[data-sn-autoplay]').forEach(autoplay);
  }
  window.SunnahFX = { scan: scan, reveal: reveal };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(document); }); } else { scan(document); }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();